<template class="p0">
  <v-app class="background-home" id="home">
    <v-main>
      <router-view></router-view>
    </v-main>
    <NavMenu />
  </v-app>
</template>

<script>
import { NavMenu } from "@/components";

export default {
  name: "home",
  components: { NavMenu },
  data: () => ({}),
  mounted() {},
  methods: {},
};
</script>

<style scoped>
.p0 {
  padding: 0%;
  margin: 0%;
}
</style>
